function ensureTrailingSlash(url) {
  if (!url) return '';
  return url.endsWith('/') ? url : `${url}/`;
}

function isTruthyEnvFlag(value) {
  return String(value || '').toLowerCase() === 'true';
}

function getTenantAwareBaseUrl() {
  if (typeof window === 'undefined' || !window.location) {
    return null;
  }

  if (isTruthyEnvFlag(process.env.REACT_APP_FORCE_ENV_API)) {
    return null;
  }

  const { hostname, origin } = window.location;
  const labels = hostname.split('.').filter(Boolean);
  const isLowerEnvPlatformHost = /^(dev|stg)\.talentgait\.ca$/.test(hostname);

  // These lower-env platform hosts should use REACT_APP_API_URL,
  // not same-origin /api.
  if (isLowerEnvPlatformHost) {
    return null;
  }

  const isCloudInfraHost =
    hostname.endsWith('.cloudfront.net') ||
    hostname.endsWith('.elasticbeanstalk.com');
  const isTenantHost =
    hostname.endsWith('.localhost') ||
    (labels.length >= 3 && !isCloudInfraHost);

  if (!isTenantHost) {
    return null;
  }

  return ensureTrailingSlash(`${origin}/api`);
}

export default function getApiBaseUrl() {
  const tenantAwareBaseUrl = getTenantAwareBaseUrl();
  if (tenantAwareBaseUrl) {
    return tenantAwareBaseUrl;
  }

  return ensureTrailingSlash(process.env.REACT_APP_API_URL || '/api');
}
